<template>
  <li>
    <pages-editions-parent-nav-link-component
      v-if="entry?.editions?.length === 1"
      :entry="entry?.editions[0]"
      :label="entry?.countryName"
    />
    <template v-else-if="entry?.editions?.length > 1">
      <pages-editions-parent-nav-link-component
        :entry="nextLink"
        :label="entry?.countryName"
        :active="isActive"
        :ignore="isActive"
      />&nbsp;<template v-for="(edition, index) in entry?.editions">
        <pages-editions-parent-nav-link-component
          :entry="edition"
          :label="edition?.editionIndex"
        />{{ index < entry?.editions?.length - 1 ? ', ' : '' }}
      </template>
    </template>
  </li>
</template>

<script setup>
const route = useRoute()
const props = defineProps({
  entry: {
    type: Object,
    required: true
  }
})

const isActive = computed(() => {
  return props?.entry?.editions?.some((edition) => {
    return edition?.slug === route?.params?.slug
  })
})

const nextLink = computed(() => {
  const index = props?.entry?.editions?.findIndex(i => i?.slug === route?.params?.slug)
  const nextIndex = index + 1
  return nextIndex < props?.entry?.editions?.length ? props?.entry?.editions[nextIndex] : props?.entry?.editions[0]
})
</script>
